import Mobile from "./card-education-mobile";
import Desktop from "./card-education-desktop";

const education = {
    Mobile,
    Desktop
}

export default education;